import { Box } from "@mui/material";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import ShCopyButton from "../../../theme/ShCopy";
import { ORDER_FILTER_KEYS } from "../../DataGrid/Filter";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import SHQuickAction from "../../../theme/Modal/SHQuickAction";
import ShLabel from "../../../theme/label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";
import OrdersCard from "../../cards/orders/OrdersCard";
import { HighlightedColumn } from "./HighlightedColumn";
import RhOrdersCard from "./cards/RhOrdersCard";
import { getTrackingLink } from "../../../../utils/shipping";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';

export const rhShipmentColumns =  (i18n,theme,t,colors,columnStrategy) => {
    
    return [
        {field: "address", 
            headerName: t("address"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                        }}
                    >
                        <Text bold>
                            {params.row.street} {params.row.house_nr}{params.row.house_nr_extra}
                        </Text>
                        <Text>
                            {params.row.postal} {params.row.city}
                        </Text>
                    </Box>
                )
            }
        },
        {
            field: "shipper", 
            headerName: t("shipper_name"),
            flex:1,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(columnStrategy !== null) {
                    if(columnStrategy.key === "shipper") {
                        const strat = columnStrategy.series.find(item => item.name === params.row.shipper?.name);
                        if(strat) {
                            return (
                                <HighlightedColumn
                                    theme={theme}
                                    value={params.row.shipper?.name}
                                    strat={strat}
                                />
                            )
                        }
                    }
                }
                return `${params.row.shipper?.name ?? ""}`
            }
        },
        {
            field: "shipper_profile", 
            headerName: t("shipper_profile"),
            flex:1,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(columnStrategy !== null) {
                    if(columnStrategy.key === "shipperprofile") {
                        const strat = columnStrategy.series.find(item => item.name === params.row.shipperProfile?.name);
                        if(strat) {
                            return (
                                <HighlightedColumn
                                    theme={theme}
                                    value={params.row.shipperProfile?.name}
                                    strat={strat}
                                />
                            )
                        }
                    }
                }
                return `${params.row.shipperProfile?.name ?? ""}`
            }
        },
     
        {
            field: "shipment_date", 
            headerName: t("shipment_date"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.shipmentDate);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <span>
                        {dateStr}<br/><Text light>{timeStr}</Text>
                    </span>
                );
                }
        },

        {field: "trackinglink", 
            headerName: t("tracking_link"),
            flex:1,
            // filter: ORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1,
                        }}
                        onClick={() => {
                            const link = getTrackingLink(params.row);
                            window.open(link, "_blank");
                        }}
                    >
                        <Text variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
                            {params.row.trackingNumber}
                        </Text>
                        <OpenInNewOutlinedIcon fontSize="small"/>
                    </Box>
                )

            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RhOrdersCard
                        // selectable={params.row.state === general_states.OPEN}
                        // select={handleCardSelection} 
                        // selected={selectedItems.includes(params.row.id)} 
                        // onClick={() => getOrderDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row}  
                    />
                )
            }
        }
    ]
};